import { createMuiTheme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Switch } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from '../../theme/CommonTheme';
import Styles from './TrustCenter.module.css';

export const SwitchPrimaryStyle = {
    switchBase: Styles.colorSwitchBase,
    checked: Styles.colorChecked,
    track: Styles.colorBar,
    disabled: Styles.disbledBar
};

export const PrimarySwitch = withStyles({
    switchBase: {
        '&$checked': {
            color: '#009ad9 !important'
        },
        '&$checked + $track': {
            backgroundColor: '#009ad9  !important'
        }
    },
    checked: {},
    track: {}
})(Switch);

export const TABLE_THEME = createMuiTheme({
    overrides: {
        MuiTableCell: {
            stickyHeader: {
                background: 'white !important'
            },
            root: {
                padding: '4px 7px !important',
                fontWeight: 'none'
            }
        },
        MuiTableBody: {
            root: {
                fontWeight: '600!important'
            }
        }
    }
});

export const TABLE_THEME_ALT = createMuiTheme({
    overrides: {
        MuiTableCell: {
            root: {
                padding: '10px 10px !important',
                fontWeight: 'none'
            }
        },
        MuiTableBody: {
            root: {
                fontWeight: '600!important'
            }
        }
    }
});

export const AUTO_COMPLETE_MULTI_SELECT = createMuiTheme({
    overrides: {
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                fontSize: '14px  !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiInputBase: {
            root: {
                display: 'flex !important',
                flexWrap: 'wrap !important',
                paddingTop: '26px !important'
            },
            input: {
                width: 'auto !important',
                paddingTop: '14px !important'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 900,
                fontSize: '14px  !important'
            }
        }
    }
});

export const FILLED_INPUT_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                // paddingTop: "20px !important",
                alignItems: 'baseline !important'
            }
        },
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '25px 12px 6px !important',
                fontSize: '14px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important'
            }
        }
    }
});

export const STD_INPUT_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiInputBase: {
            root: {
                fontSize: '14px !important'
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: '13px !important'
            }
        }
    }
});

export const FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                // paddingTop: "4px !important",
                alignItems: 'baseline !important'
            },
            loading: {
                padding: '0px !important'
            },
            listbox: {
                maxHeight: '30vh !important'
            }
        },
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '7px 12px 6px 5px !important',
                fontSize: '14px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important'
            }
        }
    }
});

export const AUTO_COMPLETE_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                paddingTop: '10px !important',
                alignItems: 'baseline !important'
            }
        },
        MuiInputBase: {
            root: {
                fontSize: '14px !important'
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: '13px !important'
            }
        }
    }
});

export const FILLED_TEXTAREA_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '0px 0px 6px !important',
                fontSize: '14px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important'
            }
        }
    }
});

export const SEARCH_BAR_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiFormControl: {
            root: {
                marginTop: -4,
                marginRight: 10
                // marginBottom: 5
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#000000',
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #000000'
                },
                '&:after': {
                    borderBottom: '2px solid #000000'
                }
            }
        }
    }
});

export const AUTO_COMPLETE_SINGLE_SELECT = FILLED_INPUT_FIELD_THEME;

export const FILLED_INPUT_MULTI_SELECT_THEME = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500',
                marginTop: '15px'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '25px 12px 6px !important',
                fontSize: '16px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            },
            root: {
                color: 'red',
                paddingLeft: '10px'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important',
                fontFamily: 'inherit',
                paddingLeft: '10px',
                paddingTop: '10px'
            }
        },
        MuiInputBase: {
            root: {
                height: '55px'
            }
        },
        MuiInputLabel: {
            formControl: {
                top: 0,
                left: 0,
                position: 'absolute'
            }
        }
    }
});

export const SWITCH_LABEL = createMuiTheme({
    overrides: {
        MuiFormLabel: {
            root: {
                fontSize: '12px !important'
            }
        }
    }
});

export const TABLE_THEME_BODY = createMuiTheme({
    overrides: {
        MuiTableCell: {
            root: {
                fontWeight: '600'
            }
        }
    }
});
